module.exports = __webpack_public_path__ + "img/icon_tone_gray.21ecf265.svg";